import React from 'react';
import { useToday } from 'shared/contexts/today';

import { useTasksTree } from '../../hooks/use-tasks-tree';
import { GroupedListProps } from '../../types';
import { NoGroupingTaskListRenderer } from './no-grouping-task-list-renderer';

export const NoGroupingTasksList: React.FC<GroupedListProps> = ({
  tasks,
  sortingMode,
  onReorder,
  customOrder = {},
  collapsedSections = [],
  onSectionCollapse,
  weekStartsOn,
  scrollElement,
  denseFormat,
  filterDocument,
  isContextMenuOpen,
  defaultNewTaskDate,
  groupSettings,
}) => {
  const today = useToday();

  const treeData = useTasksTree({
    tasks,
    sortingMode,
    customOrder,
    today,
    weekStartsOn,
    hideNewTaskRow: groupSettings.hideNewTaskRow,
  });

  return (
    <NoGroupingTaskListRenderer
      treeData={treeData}
      tasks={tasks}
      onReorder={onReorder}
      collapsedSections={collapsedSections}
      onSectionCollapse={onSectionCollapse}
      scrollElement={scrollElement}
      denseFormat={denseFormat}
      filterDocument={filterDocument}
      isContextMenuOpen={isContextMenuOpen}
      defaultNewTaskDate={defaultNewTaskDate}
      hideNewTaskRow={groupSettings.hideNewTaskRow}
      goalId={groupSettings.goalId}
      lifeAreaId={groupSettings.lifeAreaId}
      tagId={groupSettings.tagId}
      displayDue={groupSettings.displayDue}
      showRepeatingAsTodo={groupSettings.showRepeatingAsTodo}
    />
  );
};
